/**
 * 28 spec スペーシングスケール (8px グリッド)
 *
 * 一次情報: docs/design-system/03_ui_implementation_spec.md §1.2 / §2.2
 *
 * キー名は spec の `space.X` トークン名 (Tailwind 風数値) と一致させてある。
 * MUI sx の `mb: 1` = 8px (theme.spacing(1)) との対応:
 *  - SPACING_PX[2] (= 8px) = MUI `mb: 1`
 *  - SPACING_PX[4] (= 16px) = MUI `mb: 2`
 * MUI 単位は spec 数値の半分なので、用途別 SPACING (下記) で名前付き wrap している。
 *
 * 縦余白の Notion 規則:
 *  - 同種テキストブロック間          = 2-4px (mb: 0.25 - 0.5)
 *  - 見出し ⇄ 直下 property 行       = 6-8px (mb: 0.75 - 1)
 *  - 見出しブロック前後              = 12-16px (mb: 1.5 - 2)
 *  - セクション分節                  = 24px (mb: 3) + Divider
 */
export const SPACING_PX = {
  0: 0,
  '0.5': 2,
  1: 4,
  '1.5': 6,
  2: 8, // ベースグリッド
  3: 12,
  4: 16,
  5: 20,
  6: 24,
  8: 32,
  10: 40,
  12: 48,
  16: 64,
  20: 80,
  24: 96,
} as const

/**
 * コンテナ幅と固定 layout 寸法
 *
 * 一次情報: 28 spec §1.2
 *
 * 実装独自値の注記:
 *  - `sidebarWidth` は Notion 実測値 224px に統一 (Medium UI breakdown 記事で確認、 28 spec §1.2 と一致)。
 */
export const LAYOUT = {
  sidebarWidth: 224, // Notion 実測値 (medium.com/@quickmasum UI breakdown 記事で確認)
  contentMax: 720,
  contentMaxWide: '100%',
  topbarHeight: 44,
  sidebarRowHeight: 30,
  sidebarIconBarHeight: 36,
  // 最上段 WorkspaceRow (ブランド + リリース段階 + 折りたたみ). IconBar と同値だが
  // 別の行なので別名で持つ (design-book 02-components/sidebar.md).
  sidebarWorkspaceRowHeight: 36,
  blockRowMinHeight: 28,
} as const

/**
 * 共通用途の sx spacing (MUI 単位、1 = 8px)
 */
export const SPACING = {
  pageOuter: { xs: 2, sm: 3, md: 4 },
  cardPadding: 2.5, // 20px — 28 spec カード標準
  sectionGap: 3, // 24px — 28 spec ブロック間
  subSectionGap: 2, // 16px
  headingMarginTop: 1.5, // 12px — heading 前
  headingMarginBottom: 1, // 8px — heading 直下 property
  inlineGap: 1, // 8px — icon ↔ text
  // log/33 P3 cleanup: legacy spacing.legacy.ts merge
  portalPage: { xs: 2, sm: 3, md: 4 },
  mainContent: { xs: 2, sm: 3 },
  card: 3,
} as const
